module.exports = __webpack_public_path__ + "img/mobile-menu.e039c9f0.svg";